import React, { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import DataTable from "../../../Pages/InputField/DataTable";
import { pdf } from "@react-pdf/renderer";
import InventoryPDFDoc from "../../../Pages/Dashboard/InventoryPDFDoc";

const PurchaseOrderReport = () => {
  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);
  //Table per category/ sub-category
  // useEffect(() => {
  //   fetchPurchaseOrders();
  // }, []);

  // const fetchPurchaseOrders = async () => {
  //   try {
  //     const response = await axios.get(`${baseURL}/api/purchase-orders`);
  //     setData(response.data.data.reverse());
  //   } catch (error) {
  //     console.error("Error fetching purchase orders:", error);
  //   }
  // };
  useEffect(() => {
    fetchPurchaseOrders();
  }, []);

  const fetchPurchaseOrders = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/purchase-orders`);
      const allData = response.data.data.reverse();
      setRawData(allData);

      console.log("Raw data:", allData);
      const groupedData = groupByVendorAndDate(allData);
      console.log("Grouped data:", groupedData);
      console.log("Number of groups:", groupedData.length);
      
      // Log first few groups to see the structure
      groupedData.slice(0, 3).forEach((group, index) => {
        console.log(`Group ${index + 1}:`, {
          vendor_name: group.vendor_name,
          order_date: group.order_date,
          pdf_count: group.pdf_unique_ids.size,
          items_count: group.items.length
        });
      });

      const grouped = groupedData.map((group) => {
        const categories = [
          ...new Set(
            group.items.map((i) => i.vendor.category).filter(Boolean) // filters out null, undefined, "", 0, false
          ),
        ].join(", ");

        const subCategories = [
          ...new Set(
            group.items.map((i) => i.vendor.sub_category).filter(Boolean)
          ),
        ].join(", ");

        const designNames = [
          ...new Set(
            group.items
              .map((i) => i.vendor.design_master || i.item.design_name)
              .filter(Boolean)
          ),
        ].join(", ");

        return {
          pdf_unique_id: Array.from(group.pdf_unique_ids)[0] || "Multiple PDFs", // Use first PDF ID or show "Multiple PDFs"
          order_date: group.order_date,
          vendor_name: group.vendor_name,
          category: categories,
          sub_category: subCategories,
          design_name: designNames,
        };
      });

      console.log("Final grouped data:", grouped);
      setData(grouped);
    } catch (error) {
      console.error("Error fetching purchase orders:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  
  const groupByVendorAndDate = (orders) => {
    const grouped = {};

    orders.forEach((order) => {
      // Create a unique key combining vendor name and order date
      const groupKey = `${order.vendor_name}_${order.order_date}`;

      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          vendor_name: order.vendor_name,
          order_date: order.order_date,
          pdf_unique_ids: new Set(),
          items: [],
        };
      }

      // Add PDF ID to the set
      if (order.pdf_unique_id) {
        grouped[groupKey].pdf_unique_ids.add(order.pdf_unique_id);
      }

      grouped[groupKey].items.push({
        item: {
          purchase_id: order.purchase_id,
          opentag_id: order.opentag_id,
          category: order.category,
          weightBW: order.weightBW,
        },
        vendor: {
          category: order.category,
          vendor_name: order.vendor_name,
          sub_category: order.sub_category,
          design_master: order.design_master,
          order_date: order.order_date,
          pdf_unique_id: order.pdf_unique_id,
          total_items: order.total_items,
          stone_wt: order.stone_wt,
          wastage_per: order.wastage_per,
          mc_amt: order.mc_amt,
          mc_type: order.mc_type,
          purity: order.purity,
        },
      });
    });

    return Object.values(grouped);
  };

  const handleGeneratePDF = useCallback(
    async (pdf_unique_id) => {
      try {
        // Find the group that contains this PDF ID
        const groupedData = groupByVendorAndDate(rawData);
        const group = groupedData.find(g => 
          g.pdf_unique_ids.has(pdf_unique_id) || 
          Array.from(g.pdf_unique_ids)[0] === pdf_unique_id
        );

        if (!group) {
          alert("No data found for this purchase order");
          return;
        }

        if (!group.items || group.items.length === 0) {
          alert("No items found for this purchase order");
          return;
        }

        // Convert the new group structure to the format expected by InventoryPDFDoc
        const vendorBatch = {
          pdf_unique_id: pdf_unique_id,
          vendor: {
            vendor_name: group.vendor_name,
            order_date: group.order_date,
          },
          items: group.items,
        };

        const pdfWindow = window.open("", "_blank");
        if (!pdfWindow) {
          alert("Please allow popups for this site to view PDFs");
          return;
        }

        const blob = await pdf(
          <InventoryPDFDoc vendor={vendorBatch} />
        ).toBlob();
        const blobURL = URL.createObjectURL(blob);

        pdfWindow.location.href = blobURL;

        // Clean up the blob URL after a delay
        setTimeout(() => {
          URL.revokeObjectURL(blobURL);
        }, 1000);
      } catch (err) {
        console.error("Error generating PDF:", err);
        alert("Error generating PDF: " + err.message);
      }
    },
    [rawData]
  );
  const columns = React.useMemo(
    () => [
      {
        Header: "Sr. No.",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Order Date",
        accessor: "order_date",
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Vendor Name",
        accessor: "vendor_name",
      },
      {
        Header: "Category",
        accessor: "category",
      },
      {
        Header: "Sub Category",
        accessor: "sub_category",
      },
      {
        Header: "Design Name",
        accessor: (row) => row.design_name || row.design_master || "",
      },
      {
        Header: "PDF",
        accessor: "pdf",
        Cell: ({ row }) => (
          <button
            style={{
              cursor: "pointer",
              textDecoration: "none",
              background: "none",
              border: "none",
              color: "#007bff",
              padding: 0,
            }}
            onClick={() => handleGeneratePDF(row.original.pdf_unique_id)}
          >
            📝 View
          </button>
        ),
      },
    ],
    [handleGeneratePDF]
  );

  return (
    <div className="main-container">
      <div className="payments-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Purchase Order Report</h3>
          </Col>
        </Row>

        <DataTable columns={columns} data={[...data].reverse()} />
      </div>
    </div>
  );
};

export default PurchaseOrderReport;
